export default __webpack_public_path__ + "static/media/76_photo.375bee77.jpg";